import React from "react";
import jsosiflogo from "../images/jsosiflogo.png";

const Header = () => {
	return (
		<header className="bg-white border flex items-center h-24 px-4 relative md:justify-normal justify-between gap-4">
			<img
				className="h-16 sm:h-full"
				src={jsosiflogo}
				alt="logo"
				style={{
					margin: 0,
					padding: 0,
					objectFit: "cover",
				}}
			/>
			<h1 className="text-lg md:text-3xl text-[#105790] font-medium font-roboto md:absolute shrink  md:top-1/2 md:-translate-x-1/2 md:left-1/2 md:-translate-y-1/2 uppercase tracking-widest">
				Efficient Frontier
			</h1>
		</header>
	);
};

export default Header;
